import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tooltipRootFn = /* @__PURE__ */ createRecipe('tooltip__root', {}, [])

const tooltipRootVariantMap = {}

const tooltipRootVariantKeys = Object.keys(tooltipRootVariantMap)

export const tooltipRoot = /* @__PURE__ */ Object.assign(memo(tooltipRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'tooltipRoot',
  __getCompoundVariantCss__: tooltipRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tooltipRootVariantKeys,
  variantMap: tooltipRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tooltipRootVariantKeys)
  },
  getVariantProps: tooltipRootFn.getVariantProps,
})